module.exports = __webpack_public_path__ + "img/youzhi.b4c352a4.jpg";